import { Box } from "@mui/material";

const PageContent = ({ children }: { children: React.ReactNode }) => {
    return (
        <Box sx={{ height: 'calc(100vh - 59px - 32px)'}} >
            {children}
        </Box>
    );
}

export default PageContent;
